import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { tap } from "rxjs";

const apiEndpoints = {
    getSiteStatistics: `${environment.apiUrl}/site/get-stats`,
    getCameraStatistics: `${environment.apiUrl}/camera/get-stats`,
    getRuleStatistics: `${environment.apiUrl}/rule/get-stats`,
}

export type HttpListResponseFailure = { status: string, message: string };

@Injectable({
    providedIn: "root"
})
export class StatisticsService {
    private httpClient: HttpClient = inject(HttpClient);


    getSiteStatistics(siteIDs: string[], siteTimeZone: string) {
        let body = {
            'site_ids': siteIDs,
            'site_timezone': siteTimeZone
        };
        return this.httpClient.post<HttpListResponseFailure | any>(apiEndpoints.getSiteStatistics, body);
    }

    getCameraStatistics(cameraIDs: string[], siteTimeZone: string) {
        let body = {
            'camera_ids': cameraIDs,
            'site_timezone': siteTimeZone
        };
        return this.httpClient.post<HttpListResponseFailure | any>(apiEndpoints.getCameraStatistics, body);
    }

    getRuleStatistics(ruleIDs: string[], siteTimeZone: string) {
        let body = {
            'rule_ids': ruleIDs,
            'site_timezone': siteTimeZone
        };
        return this.httpClient.post<HttpListResponseFailure | any>(apiEndpoints.getRuleStatistics, body);
    }
}
